import React from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';


const AddFriend = async (user: string, friend: string) => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/friend/add/${friend}`; 
  const payload = {
    "userID": user,
  }

  try {
    const { tokens } = await fetchAuthSession();
    const authToken = tokens?.accessToken?.toString();

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': authToken!, // Assuming token is available in fetchAuthSession
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.error('Failed to add friend');
      return null;
    }
  } catch (err) {
    console.error('Failed to add friend', err);
    return null;
  }
};

export default AddFriend;
